import React, {useState , useEffect} from "react";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { Row, Col, FormGroup } from "reactstrap";
import axios from "axios";
import {useHistory,useParams} from 'react-router-dom';
import { API_URL } from "../../constent";

import {
  Block,
  BlockHead,
  PreviewCard,
  Button,
  RSelect,
} from "../../components/Component";


var userData = JSON.parse(localStorage.getItem('userData'));
var getuserid = userData?.[0]?.id;

const MainSheetNonMotor = () => {

    
    const [loading, setLoading] = useState(true);
    const [btnloading, setBtnLoading] = useState(false);
    const [product, SetProduct] = useState([]);
    const [files, setFiles] = useState([]);

    const history = useHistory();
    const params = useParams();
    var category_id = params.id;
    var policytype = params.type;

    console.log(policytype);



    function submitdata(event){

        event.preventDefault(); // Prevent default form submission behavior
        const form = event.target;
        const data = new FormData(form); // Create FormData object from the form
        const post_data = Object.fromEntries(data.entries());
        post_data['category_id'] = category_id;
        post_data['policy_type'] = policytype;
        post_data['user_id'] = getuserid;
        post_data['docs'] = files;

        setBtnLoading(true);

        axios.post(`${API_URL}savemainsheet_nonmotor` , post_data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
            .then((response)=>{
                console.log(response.data);
                if(response.data.Status === 200){
                    setBtnLoading(false);
                    alert(response.data.message);
                    history.push('/');
                }else{
                    setBtnLoading(false);
                    alert(response.data.message);
                }
            })
    }

    const handleInputChange = () => {
      const net_premium = parseFloat(document.getElementById("net_premium").value) || 0;
      const gst = parseFloat(document.getElementById("gst").value) || 0;
      document.getElementById("total_premium").value = net_premium + gst;
    }
    const onFileChange = (e) => {
      setFiles(e.target.files);
    };


  
    useEffect(() => {
      axios.get( `${API_URL}getsinglepolicy/${category_id}`).then((result)=>
        {
            console.log(result.data);
            SetProduct(result.data);
            setLoading(false);
        }) 
    },[]);

    if(loading){
        return(
            <>
            <h1>Loading......</h1>
            </>
        )
    }


  return (
    <React.Fragment>
      <Head title={`Add ${product[0]['policy_name']}`} />
      <Content>

        <Block size="lg">
          <BlockHead>
            <Row className="g-gs">
                  <Col sm="12">
                        <p className="top_head_css">ADD &gt; {product[0]['policy_name']} &gt; {policytype == 1?"RENEWAL":"NEW BUSINESS"}</p>
                  </Col>
            </Row>
          </BlockHead>
          <Row className="g-gs">
            <Col lg="12">
              <PreviewCard className="h-100">
                {/* <div className="card-head">
                  <h5 className="card-title">Contact Form</h5>
                </div> */}
                <form onSubmit={submitdata} encType="multipart/form-data">
                  <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                      PROPOSER
                    </label>
                    <input type="text" id="cf-full-name" name="proposer" className="form-control" />
                  </FormGroup>

                  <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                    ADDRESS OF CORRESPONDENCE
                    </label>
                    <input type="text" id="cf-full-name" name="address" className="form-control" />
                  </FormGroup>

                  <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                       POLICY ADDRESS
                    </label>
                    <input type="text" id="cf-full-name" name="policy_address" className="form-control" />
                  </FormGroup>

                  <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                       RISK LOCATION ADDRESS
                    </label>
                    <input type="text" id="cf-full-name" name="risk_location_address" className="form-control" />
                  </FormGroup>

                  <Row className="g-gs">
                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          EMAIL ID
                        </label>
                        <input type="text" id="cf-full-name" name="email_id" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          MOBILE NUMBER
                        </label>
                        <input type="text" id="cf-full-name" name="phone_number" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          WHATSAPP NUMBER
                        </label>
                        <input type="text" id="cf-full-name" name="whatsapp_number" className="form-control" />
                      </FormGroup>
                    </Row>

                    <Row className="g-gs">
                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          AADHAR NUMBER
                        </label>
                        <input type="text" id="cf-full-name" name="aadhar_number" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          PAN NUMBER
                        </label>
                        <input type="text" id="cf-full-name" name="pan_number" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          GSTIN NUMBER
                        </label>
                        <input type="text" id="cf-full-name" name="gst_number" className="form-control" />
                      </FormGroup>
                    </Row>

                    <Row className="g-gs">
                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          TYPE OF POLICY
                        </label>
                        <input type="text" id="cf-full-name" name="type_policy" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          COVERAGE
                        </label>
                        <input type="text" id="cf-full-name" name="coverage" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          FIRE TARIFF CODE
                        </label>
                        <input type="text" id="cf-full-name" name="fire_trf_code" className="form-control" />
                      </FormGroup>
                    </Row>

                    <Row className="g-gs">
                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          RISK CATEGORY (AS PER THE TARIFF CODE)
                        </label>
                        <input type="text" id="cf-full-name"  name="risk_code" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          SUM INSURED
                        </label>
                        <input type="text" id="cf-full-name" name="sum_insured" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                           SUM INSURED BREAKUP
                        </label>
                        <input type="text" id="cf-full-name" name="sum_insured_breakup"  className="form-control" />
                      </FormGroup>
                    </Row>

                    <Row className="g-gs">
                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="net_premium">
                        NET PREMIUM
                        </label>
                        <input type="number" id="net_premium" name="net_premium" onChange={(e) => handleInputChange()} className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="gst">
                           GST
                        </label>
                        <input type="number" id="gst" name="gst" className="form-control" onChange={(e) => handleInputChange()} />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="total_premium">
                          TOTAL PREMIUM
                        </label>
                        <input type="number" id="total_premium" name="total_premium" className="form-control" readOnly/>
                      </FormGroup>
                    </Row>

                    <Row className="g-gs">
                      <FormGroup className="form-group col-sm-6">
                        <label className="form-label" htmlFor="cf-full-name">
                          POLICY START DATE
                        </label>
                        <input type="date" id="cf-full-name"  name="policy_start_date" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-6">
                        <label className="form-label" htmlFor="cf-full-name">
                          POLICY END DATE
                        </label>
                        <input type="date" id="cf-full-name" name="policy_end_date" className="form-control" />
                      </FormGroup>
                    </Row>

    
                    <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                        PREVIOUS POLICY NUMBER
                    </label>
                    <input type="text" id="cf-full-name" name="pre_policy_no" className="form-control" />
                    </FormGroup>

                    <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                       NAME OF INSURER
                    </label>
                    <select id="cf-full-name" name="pre_policy_insurer" className="form-control">
                        <option value="">Select</option>
                        <option value="Agriculture Insurance Company of India Ltd">Agriculture Insurance Company of India Ltd</option>
                        <option value="Bajaj Allianz General Insurance Co. Ltd">Bajaj Allianz General Insurance Co. Ltd</option>
                        <option value="Cholamandalam MS General Insurance Co. Ltd">Cholamandalam MS General Insurance Co. Ltd</option>
                        <option value="Navi General Insurance Ltd.">Navi General Insurance Ltd.</option>
                        <option value="Future Generali India Insurance Co. Ltd.">Future Generali India Insurance Co. Ltd.</option>
                        <option value="HDFC ERGO General Insurance Co. Ltd">HDFC ERGO General Insurance Co. Ltd</option>
                        <option value="IFFCO-TOKIO General Insurance Co. Ltd.">IFFCO-TOKIO General Insurance Co. Ltd.</option>
                        <option value="ICICI Lombard General Insurance Co. Ltd.">ICICI Lombard General Insurance Co. Ltd.</option>
                        <option value="Kotak Mahindra General Insurance Co. Ltd.">Kotak Mahindra General Insurance Co. Ltd.</option>
                        <option value="Liberty General Insurance Co. Ltd.">Liberty General Insurance Co. Ltd.</option>
                        <option value="Magma HDI General Insurance Co. Ltd.">Magma HDI General Insurance Co. Ltd.</option>
                        <option value="National Insurance Co. Ltd.">National Insurance Co. Ltd.</option>
                        <option value="Raheja QBE General Insurance Co. Ltd.">Raheja QBE General Insurance Co. Ltd.</option>
                        <option value="Reliance General Insurance Co. Ltd.">Reliance General Insurance Co. Ltd.</option>
                        <option value="Royal Sundaram General Insurance Co. Ltd">Royal Sundaram General Insurance Co. Ltd</option>
                        <option value="SBI General Insurance Co. Ltd.">SBI General Insurance Co. Ltd.</option>
                        <option value="Shriram General Insurance Co. Ltd.">Shriram General Insurance Co. Ltd.</option>
                        <option value="Tata-AIG General Insurance Co. Ltd.">Tata-AIG General Insurance Co. Ltd.</option>
                        <option value="The New India Assurance Co. Ltd.">The New India Assurance Co. Ltd.</option>
                        <option value="The Oriental Insurance Co. Ltd.">The Oriental Insurance Co. Ltd.</option>
                        <option value="Universal Sompo General Insurance Co. Ltd.">Universal Sompo General Insurance Co. Ltd.</option>
                        <option value="United India Insurance Co. Ltd.">United India Insurance Co. Ltd.</option>
                        <option value="Acko General Insurance Ltd.">Acko General Insurance Ltd.</option>
                        <option value="Edelweiss General Insurance Company Limited">Edelweiss General Insurance Company Limited</option>
                        <option value="Go Digit General Insurance Limited">Go Digit General Insurance Limited</option>
                        <option value="Aditya Birla Health Insurance Co. Ltd.">Aditya Birla Health Insurance Co. Ltd.</option>
                        <option value="Manipal Cigna Health Insurance Company Limited">Manipal Cigna Health Insurance Company Limited</option>
                        <option value="Niva Bupa Health Insurance Company Limited">Niva Bupa Health Insurance Company Limited</option>
                        <option value="Care Health Insurance Ltd.">Care Health Insurance Ltd.</option>
                        <option value="Star Health & Allied Insurance Co. Ltd.">Star Health & Allied Insurance Co. Ltd.</option>
                    </select>
                    </FormGroup>

                    <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                         CURRENT POLICY NUMBER
                    </label>
                    <input type="text" id="cf-full-name" name="current_policy_no" className="form-control" />
                    </FormGroup>

                    <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                       NAME OF INSURER
                    </label>
                    <select id="cf-full-name" name="current_policy_insurer" className="form-control">
                        <option value="">Select</option>
                        <option value="Agriculture Insurance Company of India Ltd">Agriculture Insurance Company of India Ltd</option>
                        <option value="Bajaj Allianz General Insurance Co. Ltd">Bajaj Allianz General Insurance Co. Ltd</option>
                        <option value="Cholamandalam MS General Insurance Co. Ltd">Cholamandalam MS General Insurance Co. Ltd</option>
                        <option value="Navi General Insurance Ltd.">Navi General Insurance Ltd.</option>
                        <option value="Future Generali India Insurance Co. Ltd.">Future Generali India Insurance Co. Ltd.</option>
                        <option value="HDFC ERGO General Insurance Co. Ltd">HDFC ERGO General Insurance Co. Ltd</option>
                        <option value="IFFCO-TOKIO General Insurance Co. Ltd.">IFFCO-TOKIO General Insurance Co. Ltd.</option>
                        <option value="ICICI Lombard General Insurance Co. Ltd.">ICICI Lombard General Insurance Co. Ltd.</option>
                        <option value="Kotak Mahindra General Insurance Co. Ltd.">Kotak Mahindra General Insurance Co. Ltd.</option>
                        <option value="Liberty General Insurance Co. Ltd.">Liberty General Insurance Co. Ltd.</option>
                        <option value="Magma HDI General Insurance Co. Ltd.">Magma HDI General Insurance Co. Ltd.</option>
                        <option value="National Insurance Co. Ltd.">National Insurance Co. Ltd.</option>
                        <option value="Raheja QBE General Insurance Co. Ltd.">Raheja QBE General Insurance Co. Ltd.</option>
                        <option value="Reliance General Insurance Co. Ltd.">Reliance General Insurance Co. Ltd.</option>
                        <option value="Royal Sundaram General Insurance Co. Ltd">Royal Sundaram General Insurance Co. Ltd</option>
                        <option value="SBI General Insurance Co. Ltd.">SBI General Insurance Co. Ltd.</option>
                        <option value="Shriram General Insurance Co. Ltd.">Shriram General Insurance Co. Ltd.</option>
                        <option value="Tata-AIG General Insurance Co. Ltd.">Tata-AIG General Insurance Co. Ltd.</option>
                        <option value="The New India Assurance Co. Ltd.">The New India Assurance Co. Ltd.</option>
                        <option value="The Oriental Insurance Co. Ltd.">The Oriental Insurance Co. Ltd.</option>
                        <option value="Universal Sompo General Insurance Co. Ltd.">Universal Sompo General Insurance Co. Ltd.</option>
                        <option value="United India Insurance Co. Ltd.">United India Insurance Co. Ltd.</option>
                        <option value="Acko General Insurance Ltd.">Acko General Insurance Ltd.</option>
                        <option value="Edelweiss General Insurance Company Limited">Edelweiss General Insurance Company Limited</option>
                        <option value="Go Digit General Insurance Limited">Go Digit General Insurance Limited</option>
                        <option value="Aditya Birla Health Insurance Co. Ltd.">Aditya Birla Health Insurance Co. Ltd.</option>
                        <option value="Manipal Cigna Health Insurance Company Limited">Manipal Cigna Health Insurance Company Limited</option>
                        <option value="Niva Bupa Health Insurance Company Limited">Niva Bupa Health Insurance Company Limited</option>
                        <option value="Care Health Insurance Ltd.">Care Health Insurance Ltd.</option>
                        <option value="Star Health & Allied Insurance Co. Ltd.">Star Health & Allied Insurance Co. Ltd.</option>
                    </select>
                    </FormGroup>

                    <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                       AGENT
                    </label>
                    <input type="text" id="cf-full-name" name="agent" className="form-control" />
                    </FormGroup>

                    <Row className="g-gs">
                      <FormGroup className="form-group col-sm-6">
                        <label className="form-label" htmlFor="cf-full-name">
                         MODE OF PAYMENT
                        </label>
                        <input type="text" id="cf-full-name" name="mode_of_payment" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-6">
                        <label className="form-label" htmlFor="cf-full-name">
                        PAYMENT DETAILS
                        </label>
                        <input type="text" id="cf-full-name" name="payment_details" className="form-control" />
                      </FormGroup>

                    </Row>

                  <FormGroup className="form-group">
                    <label className="form-label" htmlFor="status">
                       STATUS OF POLICY
                    </label>
                    <select id="status" name="policy_status" className="form-control">
                        <option value="">Select</option>
                        <option value="1">ACTIVE</option>
                        <option value="2">INACTIVE</option>
                        <option value="3">CANCELLED</option>
                        <option value="4">EXPIRED</option>
                    </select>
                  </FormGroup>

                  
                  <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                      UPLOAD DOCUMENTS
                    </label>
                    <input type="file" onChange={onFileChange} id="cf-full-name" name="docs" className="form-control" multiple />
                  </FormGroup>

                  <FormGroup className="form-group">
                        <label className="form-label" htmlFor="cf-full-name">
                        NOMINEE DETAILS
                        </label>
                        <input type="text" id="cf-full-name" name="nominee" className="form-control" />
                  </FormGroup>

                  <FormGroup className="form-group">
                        <label className="form-label" htmlFor="cf-full-name">
                         NOTES
                        </label>
                        <textarea id="cf-full-name" name="note" className="form-control" />
                  </FormGroup>

                  <FormGroup className="form-group">
                    <Button disabled={btnloading} type="submit" color="primary" size="lg">
                      {btnloading ? 'Loading...' : 'Save'}
                    </Button>
                  </FormGroup>
                </form>
              </PreviewCard>
            </Col>
          </Row>
        </Block>

      </Content>
    </React.Fragment>
  );
};

export default MainSheetNonMotor;
